import api from './axios';

export const getAdminDashboardApi = (params) => api.get('/dashboard/admin/', { params });
export const getPublisherDashboardApi = (params) => api.get('/dashboard/publisher/', { params });
export const getUserDashboardApi = (params) => api.get('/dashboard/user/', { params });
